// extracted by mini-css-extract-plugin
export default {"types":"Favorites_types__ztnjr","list":"Favorites_list__pvl21","active":"Favorites_active__J0cEM"};